import {remote} from '../constants/environment';
import {ICreditCardPaymentFee} from '../interfaces/dtos/credit-card-payment-fee.interface';
import {IPostC2pPaymentResponse} from '../interfaces/services/responses';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postCreditCardPaymentFee = async (
  paymentFee: ICreditCardPaymentFee,
  token: string,
): Promise<IPostC2pPaymentResponse> => {
  const remoteURI = remote.getCreditCardPaymentPost();

  const handleResponse = async (response: Response) => {
    if (response.status === 200) {
      const data = await response.json();
      const {payload, success} = data;
      if (success && payload) {
        return {
          success: true,
          payload: null,
        };
      } else {
        return {
          success: false,
          payload: null,
        };
      }
    }
  };

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: paymentFee,
        }),
      });
    },
    handleResponse,
    remoteURI,
  )) as IPostC2pPaymentResponse;
};
